import { REGEX } from '@/constants/regex';
import { ILottieComponentProps } from '@/types/common';
import Lottie, { LottieRefCurrentProps } from 'lottie-react';
import { useRef } from 'react';
import depositAnimation from './lotties/Deposit.json';
import { replaceColor } from 'lottie-colorify';

export const DepositLottie = ({ color = '' }: ILottieComponentProps) => {
  const isValidColor = new RegExp(REGEX.HEX_COLOR).test(color);
  const coloredDepositAnimation = isValidColor
    ? replaceColor([147, 149, 152], color, depositAnimation)
    : depositAnimation;
  const lottieRef = useRef<LottieRefCurrentProps>(null);

  const handleComplete = () => {
    lottieRef.current?.goToAndStop(900);
  };

  return (
    <Lottie
      lottieRef={lottieRef}
      style={{ height: '40px' }}
      animationData={coloredDepositAnimation}
      loop={false}
      onComplete={handleComplete}
    />
  );
};
